import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';

/**
 * @ngdoc component
 * @name  sync-button
 * @description
 *
 * Renders a button with given properties
 *
 * @example
 *  <sync-button [disabled]="true" text="Submit" type="primary" (click)="submit()"></sync-button>
 *  <sync-button text="Close" type="secondary" (click)="cancel()"></sync-button>
 */
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        /**
        * @property {string} text
        * text of the button
        */
        this.text = '';
        /**
        * @property {boolean} disabled
        * Flag to disable the button
        * Default value is false. passing this value true will disable the button
        */
        this.disabled = false;
        /**
        * @property {Function} onClick
        * Callback function on button click. Alternatively (click)="func()" can also be used on <sync-button>.
        */
        this.onClick = function () { };
        this.typeClassList = {
            'primary': 'btn-primary',
            'secondary': 'btn-default'
        };
        this.sizeClassObjList = {
            'small': 'btn-sm',
            'medium': 'btn-md',
            'large': 'btn-lg',
        };
    }
    ButtonComponent.prototype.ngOnInit = function () {
        this.typeClass = this.typeClassList[this.type] || 'btn-primary';
        this.sizeClass = this.sizeClassObjList[this.size] || 'btn-md';
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sync-button',
                    template: "<button [disabled]=\"disabled\" class=\"btn\" [ngClass]=\"[typeClass, sizeClass]\" (click)=\"onClick()\">{{text}}</button>",
                    styles: [".btn-primary{background-color:#00adef;border-color:#00adef;color:#fff}.btn-primary:hover{background-color:#0d3b66;border-color:#0d3b66}.btn-default{margin-bottom:0;margin-left:5px}.btn-md{font-size:17px}"]
                }] }
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return []; };
    ButtonComponent.propDecorators = {
        text: [{ type: Input }],
        disabled: [{ type: Input }],
        type: [{ type: Input }],
        size: [{ type: Input }],
        onClick: [{ type: Input }]
    };
    return ButtonComponent;
}());

var SyncLibraryModule = /** @class */ (function () {
    function SyncLibraryModule() {
    }
    SyncLibraryModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ButtonComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ButtonComponent
                    ]
                },] }
    ];
    return SyncLibraryModule;
}());

/*
 * Public API Surface of sync-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SyncLibraryModule, ButtonComponent };

//# sourceMappingURL=sync-library.js.map